// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type OptionsTooltip_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, code: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined };

export type OptionsTooltip_ReadyPlanOptionGroupFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined };

export const OptionsTooltip_ReadyPlanOptionFragmentDoc = gql`
    fragment OptionsTooltip_ReadyPlanOption on ReadyPlanOption {
  id
  name
  code
  readyPlanLocation {
    id
    location {
      id
      displayLocationPath
    }
  }
}
    `;
export const OptionsTooltip_ReadyPlanOptionGroupFragmentDoc = gql`
    fragment OptionsTooltip_ReadyPlanOptionGroup on ReadyPlanOptionGroup {
  id
  name
  readyPlanLocation {
    id
    location {
      id
      displayLocationPath
    }
  }
}
    `;